import get from 'lodash/get';

const denouceStatus = {
    pending: 'En attente',
    waiting: 'Att Ret Prom.',
    accepted: 'Acceptée',
    refused: 'Refusée',
    canceled: 'Annulée'
};

function formatDenouceStatus(value: string) {
    return get(denouceStatus, value, value);
}

export { denouceStatus, formatDenouceStatus };
